<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Business Type Analytics</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Business Type Analytics by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link href="assets/images/favicon.svg" rel="shortcut icon">
    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- Start right Content here -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Business Type Analytics</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item active">Business Type Analytics</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <ToolBar/>

          <!-- Summary Cards -->
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total Business Types</p>
                      <h4 class="mb-0">{{ numberFormat(totalBusinessTypes) }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title">
                          <i class="bx bx-category font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total Businesses</p>
                      <h4 class="mb-0">{{ numberFormat(totalBusinesses) }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title">
                          <i class="bx bx-store font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Most Popular Type</p>
                      <h4 class="mb-0 text-truncate">{{ mostPopularType || '-' }}</h4>
                      <p class="text-muted mb-0"><small>{{ numberFormat(mostPopularCount) }} businesses</small></p>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title">
                          <i class="bx bx-trending-up font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Average per Type</p>
                      <h4 class="mb-0">{{ numberFormat(averagePerType) }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title">
                          <i class="bx bx-bar-chart font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Filters and Search -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center mb-2">
                    <div class="col-md-8">
                      <div class="d-flex align-items-center">
                        <div class="me-3">
                          <label class="form-label mb-0 me-2 fw-semibold">
                            <i class="bx bx-map me-1"></i>Location Filter:
                          </label>
                        </div>
                        <div class="me-2">
                          <select v-model="selectedSubCounty" @change="onLocationFilterChange" class="form-select">
                            <option value="">All Sub Counties</option>
                            <option v-for="sc in subCounties" :key="sc.subCountyID" :value="sc.subCountyID">
                              {{ sc.subCountyName }}
                            </option>
                          </select>
                        </div>
                        <div class="me-2">
                          <select v-model="selectedWard" @change="onLocationFilterChange" class="form-select" :disabled="!selectedSubCounty">
                            <option value="">All Wards</option>
                            <option v-for="ward in filteredWards" :key="ward.wardID" :value="ward.wardID">
                              {{ ward.wardName }}
                            </option>
                          </select>
                        </div>
                        <button @click="clearLocationFilters" class="btn btn-outline-secondary" v-if="selectedSubCounty || selectedWard">
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <input v-model="search" type="text" class="form-control" placeholder="Search business types...">
                        <span class="input-group-text"><i class="bx bx-search"></i></span>
                      </div>
                    </div>
                  </div>

                  <!-- Export Buttons Row -->
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex justify-content-end gap-2">
                        <button
                            v-if="getRight('EXPORT BUSINESS TYPE')"
                            @click="exportCurrentPage"
                            class="btn btn-success btn-sm"
                            :disabled="isExporting || filteredBusinessTypes.length === 0">
                          <i class="bx bxs-download me-1"></i>
                          {{ isExporting ? 'Exporting...' : 'Export Current Page' }}
                        </button>
                        <button
                            v-if="getRight('EXPORT BUSINESS TYPE')"
                            @click="exportAllTypes"
                            class="btn btn-primary btn-sm"
                            :disabled="isExporting || filteredBusinessTypes.length === 0">
                          <i class="bx bxs-download me-1"></i>
                          {{ isExporting ? 'Exporting...' : 'Export All Types' }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Business Types Grid -->
                <div class="card-body">
                  <div class="row" v-if="!loading && filteredBusinessTypes.length > 0">
                    <div class="col-xl-3 col-lg-4 col-md-6 mb-4" v-for="(type, index) in paginatedBusinessTypes" :key="index">
                      <div class="card business-type-card h-100" @click="viewBusinessesByType(type)">
                        <div class="card-body">
                          <div class="d-flex justify-content-between align-items-start mb-3">
                            <div class="flex-grow-1">
                              <h5 class="card-title text-primary mb-2 text-truncate" :title="type.businessDes">
                                {{ type.businessDes }}
                              </h5>
                            </div>
                            <div class="flex-shrink-0">
                              <span class="badge bg-primary font-size-14">{{ numberFormat(type.count) }}</span>
                            </div>
                          </div>

                          <div class="mb-3">
                            <div class="progress" style="height: 8px;">
                              <div
                                  class="progress-bar bg-primary"
                                  role="progressbar"
                                  :style="{ width: getPercentage(type.count) + '%' }"
                                  :aria-valuenow="getPercentage(type.count)"
                                  aria-valuemin="0"
                                  aria-valuemax="100">
                              </div>
                            </div>
                            <small class="text-muted">{{ getPercentage(type.count) }}% of total</small>
                          </div>

                          <!-- Location breakdown if filter applied -->
                          <div v-if="type.locationBreakdown && type.locationBreakdown.length > 0" class="mb-2">
                            <small class="text-muted fw-semibold">Location Distribution:</small>
                            <div v-for="(loc, idx) in type.locationBreakdown.slice(0, 3)" :key="idx" class="d-flex justify-content-between">
                              <small class="text-muted">{{ loc.name }}</small>
                              <small class="text-muted">{{ loc.count }}</small>
                            </div>
                            <small v-if="type.locationBreakdown.length > 3" class="text-muted">
                              +{{ type.locationBreakdown.length - 3 }} more locations
                            </small>
                          </div>

                          <button class="btn btn-sm btn-outline-primary w-100 mt-2">
                            <i class="bx bx-show me-1"></i>View Businesses
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Loading state -->
                  <div class="text-center py-5" v-if="loading">
                    <div class="spinner-border text-primary m-1" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <h4 class="mt-3">Loading Business Types...</h4>
                  </div>

                  <!-- No results -->
                  <div class="text-center py-5" v-if="!loading && filteredBusinessTypes.length === 0">
                    <img :src="'./assets/images/no-results.png'" alt="No results" class="img mb-4" style="max-width: 200px;"/>
                    <h4>No Business Types Found</h4>
                    <p class="text-muted">Try adjusting your search or location filters</p>
                    <button @click="clearAllFilters" class="btn btn-primary mt-2">
                      <i class="bx bx-refresh me-1"></i>Reset Filters
                    </button>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white" v-if="!loading && filteredBusinessTypes.length > 0">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div class="d-flex align-items-center">
                        <span class="me-2">Show:</span>
                        <select class="form-select w-auto" v-model="itemsPerPage">
                          <option value="12">12</option>
                          <option value="24">24</option>
                          <option value="48">48</option>
                          <option value="96">96</option>
                        </select>
                        <span class="ms-2">per page</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <nav>
                        <ul class="pagination justify-content-end mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" @click="prevPage" tabindex="-1">Previous</a>
                          </li>
                          <li
                              class="page-item"
                              :class="{ active: currentPage === page }"
                              v-for="page in paginationRange"
                              :key="page"
                          >
                            <span class="page-link" v-if="page === '...'">{{ page }}</span>
                            <a class="page-link" @click="goToPage(page)" v-else>{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage">Next</a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Business List Modal -->
    <div class="modal fade" id="businessListModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title text-white">
              <i class="bx bx-store me-2"></i>
              {{ selectedType }} Businesses
              <span class="badge bg-light text-primary ms-2">{{ businessDetails.length }}</span>
            </h5>
            <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
          </div>

          <div class="modal-body">
            <!-- Modal Filters -->
            <div class="row mb-3">
              <div class="col-md-6">
                <input
                    v-model="modalSearch"
                    type="text"
                    class="form-control"
                    placeholder="Search businesses...">
              </div>
              <div class="col-md-3">
                <select v-model="modalSubCountyFilter" class="form-select">
                  <option value="">All Sub Counties</option>
                  <option v-for="sc in modalSubCounties" :key="sc" :value="sc">{{ sc }}</option>
                </select>
              </div>
              <div class="col-md-3">
                <button
                    v-if="getRight('EXPORT BUSINESS TYPE')"
                    @click="downloadBusinessList"
                    class="btn btn-success w-100"
                    :disabled="isDownloadingList">
                  <i class="bx bxs-download me-1"></i>
                  {{ isDownloadingList ? 'Downloading...' : 'Download List' }}
                </button>
              </div>
            </div>

            <!-- Business List Table -->
            <div class="table-responsive">
              <table class="table table-hover table-striped align-middle">
                <thead class="table-light">
                <tr>
                  <th>Business ID</th>
                  <th>Business Name</th>
                  <th>Owner</th>
                  <th>Location</th>
                  <th>Contact</th>
                  <th>Date Created</th>
                  <th class="text-center">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(business, index) in filteredModalBusinesses" :key="index">
                  <td>{{ business.businessID }}</td>
                  <td>
                    <strong>{{ business.businessName }}</strong><br>
                    <small class="text-muted">{{ business.businessCategory }}</small>
                  </td>
                  <td>{{ business.fullnames || business.contactPersonNames }}</td>
                  <td>
                    <strong>{{ business.subCountyName }}</strong><br>
                    <small class="text-muted">{{ business.wardName }}</small>
                    <small v-if="business.zone" class="d-block text-muted">Zone: {{ business.zone }}</small>
                  </td>
                  <td>{{ business.contactPersonPhone || business.ownerPhone }}</td>
                  <td>
                    <small>{{ formattedDate(business.dateCreated) }}</small>
                  </td>
                  <td class="text-center">
                    <button @click="viewBusinessDetails(business)" class="btn btn-sm btn-primary">
                      <i class="bx bx-show"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>

              <!-- Modal No Results -->
              <div v-if="filteredModalBusinesses.length === 0" class="text-center py-4">
                <p class="text-muted">No businesses found matching your criteria</p>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Business Details Modal -->
    <div class="modal fade" id="businessDetailsModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title text-white">
              <i class="bx bx-store me-2"></i>Business Details
            </h5>
            <button type="button" class="btn-close btn-close-white" @click="closeBusinessDetails"></button>
          </div>

          <div class="modal-body" v-if="selectedBusiness">
            <!-- Business Information -->
            <div class="row mb-4">
              <div class="col-md-12">
                <h5 class="text-primary mb-3">
                  <i class="bx bx-info-circle me-2"></i>Basic Information
                </h5>
                <div class="card border-0 shadow-sm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Business ID</label>
                        <p class="mb-0 fw-bold">{{ selectedBusiness.businessID }}</p>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Business Name</label>
                        <p class="mb-0 fw-bold">{{ selectedBusiness.businessName }}</p>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Business Category</label>
                        <p class="mb-0">{{ selectedBusiness.businessCategory }}</p>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Business Type</label>
                        <p class="mb-0">{{ selectedBusiness.businessDes || selectedType }}</p>
                      </div>
                      <div class="col-md-6 mb-3" v-if="selectedBusiness.businessSubCategory">
                        <label class="text-muted small">Sub Category</label>
                        <p class="mb-0">{{ selectedBusiness.businessSubCategory }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Location Information -->
            <div class="row mb-4">
              <div class="col-md-12">
                <h5 class="text-primary mb-3">
                  <i class="bx bx-map me-2"></i>Location Details
                </h5>
                <div class="card border-0 shadow-sm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Sub County</label>
                        <p class="mb-0 fw-bold">{{ selectedBusiness.subCountyName }}</p>
                        <small class="text-muted">ID: {{ selectedBusiness.subCountyID }}</small>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Ward</label>
                        <p class="mb-0 fw-bold">{{ selectedBusiness.wardName }}</p>
                        <small class="text-muted">ID: {{ selectedBusiness.wardID }}</small>
                      </div>
                      <div class="col-md-12 mb-3" v-if="selectedBusiness.zone">
                        <label class="text-muted small">Zone</label>
                        <p class="mb-0">{{ selectedBusiness.zone }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Owner/Contact Information -->
            <div class="row mb-4">
              <div class="col-md-12">
                <h5 class="text-primary mb-3">
                  <i class="bx bx-user me-2"></i>Owner/Contact Information
                </h5>
                <div class="card border-0 shadow-sm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Owner Name</label>
                        <p class="mb-0">{{ selectedBusiness.fullnames || selectedBusiness.contactPersonNames || 'N/A' }}</p>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Contact Phone</label>
                        <p class="mb-0">
                          <i class="bx bx-phone me-1"></i>
                          {{ selectedBusiness.contactPersonPhone || selectedBusiness.ownerPhone || 'N/A' }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Registration Information -->
            <div class="row mb-4">
              <div class="col-md-12">
                <h5 class="text-primary mb-3">
                  <i class="bx bx-calendar me-2"></i>Registration Details
                </h5>
                <div class="card border-0 shadow-sm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Created By</label>
                        <p class="mb-0">{{ selectedBusiness.createdBy }}</p>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="text-muted small">Date Created</label>
                        <p class="mb-0">{{ formattedDate(selectedBusiness.dateCreated) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeBusinessDetails">
              <i class="bx bx-x me-1"></i>Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"></div>
          <div class="col-sm-6">
            <div class="text-sm-end d-sm-block">
              County Government
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ToolBar from "@/components/sbp/ToolBar";
import {biller, execute, getRight, trade} from "@/api";
import moment from 'moment'

export default {
  name: "BusinessTypeAnalytics",
  components: {
    ToolBar,
    NavigationBar
  },

  data() {
    return {
      loading: false,
      isExporting: false,
      search: '',

      // Business types data
      businessTypes: [],
      totalBusinesses: 0,

      // Summary stats
      totalBusinessTypes: 0,
      mostPopularType: '',
      mostPopularCount: 0,
      averagePerType: 0,

      // Location filters
      selectedSubCounty: '',
      selectedWard: '',
      subCounties: [],
      wards: [],

      // Pagination
      currentPage: 1,
      itemsPerPage: 24,

      // Modal
      selectedType: '',
      businessDetails: [],
      modalSearch: '',
      modalSubCountyFilter: '',
      isDownloadingList: false,
      selectedBusiness: null,
    }
  },

  computed: {
    filteredBusinessTypes() {
      let filtered = this.businessTypes;

      if (this.search) {
        filtered = filtered.filter(type =>
            type.businessDes.toLowerCase().includes(this.search.toLowerCase())
        );
      }

      return filtered.sort((a, b) => b.count - a.count);
    },

    totalPages() {
      return Math.ceil(this.filteredBusinessTypes.length / this.itemsPerPage);
    },

    paginatedBusinessTypes() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredBusinessTypes.slice(start, end);
    },

    paginationRange() {
      const range = [];
      const delta = 2;
      const left = this.currentPage - delta;
      const right = this.currentPage + delta + 1;
      let last = 0;

      for (let i = 1; i <= this.totalPages; i++) {
        if (i === 1 || i === this.totalPages || (i >= left && i < right)) {
          if (last + 1 !== i) {
            range.push('...');
          }
          range.push(i);
          last = i;
        }
      }

      return range;
    },

    filteredWards() {
      if (!this.selectedSubCounty) return [];
      return this.wards.filter(w => w.subCountyID === this.selectedSubCounty);
    },

    modalSubCounties() {
      const subCounties = new Set();
      this.businessDetails.forEach(b => {
        if (b.subCountyName) subCounties.add(b.subCountyName);
      });
      return Array.from(subCounties).sort();
    },

    filteredModalBusinesses() {
      let filtered = this.businessDetails;

      if (this.modalSearch) {
        const search = this.modalSearch.toLowerCase();
        filtered = filtered.filter(b =>
            b.businessName.toLowerCase().includes(search) ||
            b.businessID.toLowerCase().includes(search) ||
            (b.fullnames && b.fullnames.toLowerCase().includes(search)) ||
            (b.contactPersonNames && b.contactPersonNames.toLowerCase().includes(search))
        );
      }

      if (this.modalSubCountyFilter) {
        filtered = filtered.filter(b => b.subCountyName === this.modalSubCountyFilter);
      }

      return filtered;
    }
  },

  watch: {
    itemsPerPage() {
      this.currentPage = 1;
    },
    search() {
      this.currentPage = 1;
    }
  },

  mounted() {
    this.getBusinessTypeStatistics();
    this.getSubCountiesAndWards();
    this.menuAccess();
  },

  methods: {
    getRight(type) {
      return getRight(type)
    },

    getBusinessTypeStatistics() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getBusinessTypeStatistics");

      if (this.selectedSubCounty) {
        data.append("filterSubCountyID", this.selectedSubCounty);
      }

      if (this.selectedWard) {
        data.append("filterWardID", this.selectedWard);
      }

      execute(data, trade)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.businessTypes = res.data.data.businessTypes || [];
              this.totalBusinessTypes = this.businessTypes.length;
              this.totalBusinesses = this.businessTypes.reduce((sum, type) => sum + parseInt(type.count || 0), 0);

              if (this.businessTypes.length > 0) {
                const sorted = [...this.businessTypes].sort((a, b) => parseInt(b.count) - parseInt(a.count));
                this.mostPopularType = sorted[0].businessDes;
                this.mostPopularCount = parseInt(sorted[0].count);
                this.averagePerType = Math.round(this.totalBusinesses / this.totalBusinessTypes);
              }
            } else {
              this.showMessage(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.loading = false;
            this.showMessage('Error loading business type statistics: ' + e.message, 'error');
          });
    },

    viewBusinessesByType(type) {
      this.selectedType = type.businessDes;
      this.businessDetails = [];
      this.modalSearch = '';
      this.modalSubCountyFilter = '';

      const data = new FormData();
      data.append("function", "getBusinessesByType");
      data.append("businessDes", type.businessDes);

      if (this.selectedSubCounty) {
        data.append("filterSubCountyID", this.selectedSubCounty);
      }

      if (this.selectedWard) {
        data.append("filterWardID", this.selectedWard);
      }

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.businessDetails = res.data.data.businesses || [];

              const modal = new bootstrap.Modal(document.getElementById('businessListModal'));
              modal.show();
            } else {
              this.showMessage(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showMessage('Error loading businesses: ' + e.message, 'error');
          });
    },

    closeModal() {
      const modalElement = document.getElementById('businessListModal');
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    },

    viewBusinessDetails(business) {
      this.selectedBusiness = business;

      const listModal = bootstrap.Modal.getInstance(document.getElementById('businessListModal'));
      if (listModal) {
        listModal.hide();
      }

      setTimeout(() => {
        const detailsModal = new bootstrap.Modal(document.getElementById('businessDetailsModal'));
        detailsModal.show();
      }, 300);
    },

    closeBusinessDetails() {
      const detailsModal = bootstrap.Modal.getInstance(document.getElementById('businessDetailsModal'));
      if (detailsModal) {
        detailsModal.hide();
      }
      this.selectedBusiness = null;

      setTimeout(() => {
        const listModal = new bootstrap.Modal(document.getElementById('businessListModal'));
        listModal.show();
      }, 300);
    },

    exportCurrentPage() {
      if (this.paginatedBusinessTypes.length === 0) {
        this.showMessage('No business types to export', 'warning');
        return;
      }

      this.isExporting = true;

      try {
        const csv = this.generateBusinessTypesCSV(this.paginatedBusinessTypes);
        const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const filename = this.generateFilename('page');

        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.showMessage(`Successfully exported ${this.paginatedBusinessTypes.length} business types`, 'success');
      } catch (error) {
        this.showMessage('Failed to export: ' + error.message, 'error');
      } finally {
        this.isExporting = false;
      }
    },

    exportAllTypes() {
      if (this.filteredBusinessTypes.length === 0) {
        this.showMessage('No business types to export', 'warning');
        return;
      }

      this.isExporting = true;

      try {
        const csv = this.generateBusinessTypesCSV(this.filteredBusinessTypes);
        const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const filename = this.generateFilename('all');

        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.showMessage(`Successfully exported ${this.filteredBusinessTypes.length} business types`, 'success');
      } catch (error) {
        this.showMessage('Failed to export: ' + error.message, 'error');
      } finally {
        this.isExporting = false;
      }
    },

    generateBusinessTypesCSV(types) {
      const headers = [
        'NO.',
        'Business Type',
        'Total Businesses',
        'Percentage',
        'Sub Counties',
        'Wards',
        'Zones'
      ];

      let csv = headers.join(',') + '\n';

      types.forEach((item, index) => {
        const row = [
          index + 1,
          this.escapeCSV(item.businessDes),
          item.count,
          this.getPercentage(item.count) + '%',
          item.subCountyCount || 0,
          item.wardCount || 0,
          item.zoneCount || 0
        ];
        csv += row.join(',') + '\n';
      });

      csv += '\n';
      csv += 'SUMMARY\n';
      csv += `Total Business Types,${types.length}\n`;
      csv += `Total Businesses,${this.totalBusinesses}\n`;
      csv += `Average per Type,${this.averagePerType}\n`;

      if (this.selectedSubCounty || this.selectedWard || this.search) {
        csv += '\n';
        csv += 'FILTERS APPLIED\n';
        if (this.selectedSubCounty) {
          const scName = this.subCounties.find(s => s.subCountyID === this.selectedSubCounty)?.subCountyName || '';
          csv += `Sub County,${scName}\n`;
        }
        if (this.selectedWard) {
          const wardName = this.wards.find(w => w.wardID === this.selectedWard)?.wardName || '';
          csv += `Ward,${wardName}\n`;
        }
        if (this.search) {
          csv += `Search,${this.search}\n`;
        }
      }

      csv += '\n';
      csv += `Generated At,${moment().format('YYYY-MM-DD HH:mm:ss')}\n`;

      return csv;
    },

    generateFilename(type) {
      let filename = 'Business_Type_Analytics_';

      if (type === 'page') {
        filename += `Page_${this.currentPage}_`;
      } else {
        filename += 'All_';
      }

      if (this.selectedSubCounty) {
        const scName = this.subCounties.find(s => s.subCountyID === this.selectedSubCounty)?.subCountyName || '';
        filename += scName.replace(/\s+/g, '_') + '_';
      }

      if (this.selectedWard) {
        const wardName = this.wards.find(w => w.wardID === this.selectedWard)?.wardName || '';
        filename += wardName.replace(/\s+/g, '_') + '_';
      }

      filename += moment().format('YYYY-MM-DD_HHmmss') + '.csv';

      return filename;
    },

    downloadBusinessList() {
      if (this.filteredModalBusinesses.length === 0) {
        this.showMessage('No businesses to download', 'warning');
        return;
      }

      this.isDownloadingList = true;

      try {
        const csv = this.generateBusinessListCSV(this.filteredModalBusinesses);
        const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `${this.selectedType}_Businesses_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.showMessage(`Successfully downloaded ${this.filteredModalBusinesses.length} businesses`, 'success');
      } catch (error) {
        this.showMessage('Failed to download: ' + error.message, 'error');
      } finally {
        this.isDownloadingList = false;
      }
    },

    generateBusinessListCSV(businesses) {
      const headers = [
        'NO.',
        'Business ID',
        'Business Name',
        'Business Category',
        'Business Type',
        'Sub County',
        'Ward',
        'Zone',
        'Owner Name',
        'Contact Phone',
        'Created By',
        'Date Created'
      ];

      let csv = headers.join(',') + '\n';

      businesses.forEach((item, index) => {
        const row = [
          index + 1,
          this.escapeCSV(item.businessID),
          this.escapeCSV(item.businessName),
          this.escapeCSV(item.businessCategory),
          this.escapeCSV(item.businessDes || this.selectedType),
          this.escapeCSV(item.subCountyName),
          this.escapeCSV(item.wardName),
          this.escapeCSV(item.zone || ''),
          this.escapeCSV(item.fullnames || item.contactPersonNames || ''),
          this.escapeCSV(item.contactPersonPhone || item.ownerPhone || ''),
          this.escapeCSV(item.createdBy),
          this.escapeCSV(this.formattedDate(item.dateCreated))
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    getSubCountiesAndWards() {
      const data = new FormData();
      data.append("function", "getSubCounties");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              const rawData = res.data.data.subCounties;

              const subCountyMap = new Map();
              rawData.forEach(item => {
                if (!subCountyMap.has(item.subCountyID)) {
                  subCountyMap.set(item.subCountyID, {
                    subCountyID: item.subCountyID,
                    subCountyName: item.subCountyName
                  });
                }
              });
              this.subCounties = Array.from(subCountyMap.values());

              const wardMap = new Map();
              rawData.forEach(item => {
                if (!wardMap.has(item.wardID)) {
                  wardMap.set(item.wardID, {
                    wardID: item.wardID,
                    wardName: item.wardName,
                    subCountyID: item.subCountyID
                  });
                }
              });
              this.wards = Array.from(wardMap.values());
            }
          })
          .catch((e) => {
            console.error("Error loading subcounties:", e);
          });
    },

    onLocationFilterChange() {
      if (!this.selectedSubCounty) {
        this.selectedWard = '';
      }
      this.currentPage = 1;
      this.getBusinessTypeStatistics();
    },

    clearLocationFilters() {
      this.selectedSubCounty = '';
      this.selectedWard = '';
      this.getBusinessTypeStatistics();
    },

    clearAllFilters() {
      this.search = '';
      this.selectedSubCounty = '';
      this.selectedWard = '';
      this.currentPage = 1;
      this.getBusinessTypeStatistics();
    },

    getPercentage(count) {
      if (this.totalBusinesses === 0) return 0;
      const numCount = parseInt(count || 0);
      return Math.round((numCount / this.totalBusinesses) * 100);
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      if (page !== '...' && page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },

    formattedDate(date) {
      return moment(date).format('DD MMM YYYY')
    },

    showMessage(message, type = 'info') {
      console.log(`${type}: ${message}`);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Business Type Analytics");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then((res) => {})
          .catch((e) => {});
    }
  }
}
</script>

<style scoped>
.business-type-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e3e6f0;
}

.business-type-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: #4e73df;
}

.business-type-card .card-body {
  padding: 1.5rem;
}

.business-type-card .card-title {
  font-size: 1rem;
  font-weight: 600;
  min-height: 2.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mini-stats-wid .mini-stat-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-xl {
  max-width: 1200px;
}

.table-hover tbody tr {
  cursor: pointer;
}

.progress {
  background-color: #e9ecef;
}
</style>